import React from "react";
import "./TermsAndConditions.css";
import { Link } from "react-router-dom";
const DisputeRedressalMechanism = () => {
  
  return (
    <div className="page-body">
    <div className="terms-container">
     {/* <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
          <h5 className="page-title mt-3"><strong>Dispute Redressal Mechanism</strong></h5>
          <div className="breadcrumb m-0 text-end">
             <Link to="/compliance-center">Compliance Center</Link> &nbsp;&gt;&nbsp;
            <strong>Dispute Redressal Mechanism</strong>
          </div>
        </div> */}
 <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
  <h5 className="page-title mt-3">
    <p style={{fontWeight:"600"}}>Dispute Redressal Mechanism</p>
  </h5>
<div className="breadcrumb m-0 text-end">
  <Link to="/" className="breadcrumb-link">
    Home
  </Link>
  &nbsp;&gt;&nbsp;
  <Link to="/compliance-center" className="breadcrumb-link">
    Compliance Center
  </Link>
  &nbsp;&gt;&nbsp;
  <span className="breadcrumb-current">Dispute Redressal Mechanism</span>
</div>
</div>

<ol>
<li>Every end-user customer can raise a complaint with respect to a UPI transaction, on the PSP app / TPAP app.</li>
<li>End-user customer can select the relevant UPI transaction and raise a complaint in relation thereto</li>
<li>A complaint shall be first raised with the relevant TPAP in respect to all UPI related grievances / complaints of the end-user customers on-boarded by the PSP Bank / TPAP (if the UPI transaction is made through TPAP app). In case the complaint / grievance remains unresolved, the next level for escalation will be the PSP Bank, followed by the bank (where the end-user customer maintains its account) and NPCI, in the same order. After exercising these options, the end-user customer can approach the Banking Ombudsman and / or the Ombudsman for Digital Complaints, as the case may be.</li>
<li>The complaint can be raised for both the types of transactions i.e. fund transfer and merchant transactions</li>
<li>The end-user customer shall be kept communicated by the PSP / TPAP by means of updating the status of such end-user customer’s complaint on the relevant app itself.</li>
</ol>



  </div>
  </div>
  );
};

export default DisputeRedressalMechanism;
